export const meta = {
  slug: { de: "patientenanfragen-effizient-bearbeiten", en: "handle-patient-inquiries-calmly" },
  title: "Patientenanfragen ruhig bearbeiten: Strukturen, die wirklich entlasten",
  excerpt:
    "Anfragen kommen über viele Kanäle und unterbrechen den Praxisalltag. Klare Strukturen helfen, sie ruhig und vollständig zu bearbeiten.",
  category: "praxen",
  publishedAt: "2026-04-14",
  updatedAt: "2026-05-06",
  metaTitle: "Patientenanfragen strukturieren | OnePractix",
  metaDescription:
    "Wie Praxen Patientenanfragen über Telefon, Mail und Web ruhig strukturieren und bearbeiten – ohne den Praxisalltag ständig zu unterbrechen.",
  related: ["telefonservice-praxis-sinnvoll", "praxisorganisation-verbessern"],
  en: {
    title: "Handling patient requests calmly: structures that work",
    metaTitle: "Handling patient requests calmly | OnePractix",
    metaDescription:
      "How practices structure patient requests across phone, email and web — calmly and reliably, without constant interruptions.",
    excerpt:
      "Requests come in via many channels and interrupt everyday practice. Clear structures help to handle them calmly and completely.",
  },
};

export default meta;
